const GaugeArrow = (props) => (
  <svg
    width="108"
    height="15"
    viewBox="0 0 108 15"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8.6499L54.0795 14.1911C56.9569 14.486 59.6631 12.7759 60.6321 10.0506C61.346 8.04282 60.9922 5.81 59.6927 4.12121L59.3589 3.68738C57.7508 1.59752 55.1384 0.540548 52.5295 0.924245L0 8.6499Z"
      fill="#C0CBD8"
    />
  </svg>
)

export default GaugeArrow
